import { render, staticRenderFns } from "./BookingExpiredCard.vue?vue&type=template&id=36eaa1a4&scoped=true&"
import script from "./BookingExpiredCard.vue?vue&type=script&lang=js&"
export * from "./BookingExpiredCard.vue?vue&type=script&lang=js&"
import style0 from "./BookingExpiredCard.vue?vue&type=style&index=0&id=36eaa1a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eaa1a4",
  null
  
)

export default component.exports